export default {
  equipmentHeaders: {
    name: 'EQUIPMENT_NAME',
    location: 'EQUIPMENT_LOCATION',
    charPb1: 'EQUIPMENT_CHAR_PB_1',
    charPb2: 'EQUIPMENT_CHAR_PB_2',
    follow: 'EQUIPMENT_FOLLOWED_BY',
    description: 'EQUIPMENT_DESCRIPTION'
  },
  equipmentDisabled: 'EQUIPMENT_DISABLED',
  vehicleDisabled: 'VEHICLE_DISABLED',
  equipmentModal: {
    create: 'EQUIPMENT_CREATE',
    update: 'EQUIPMENT_UPDATE',
    firstSectionTitle: 'EQUIPMENT_FIRST_SECTION_TITLE',
    secondSectionTitle: 'EQUIPMENT_SECOND_SECTION_TITLE',
    brand: 'EQUIPMENT_BRAND',
    reference: 'EQUIPMENT_REFERENCE',
    number: 'EQUIPMENT_NUMBER'
  },
  vehicleModal: {
    create: 'VEHICLE_CREATE',
    update: 'VEHICLE_UPDATE',
  },
  maintenanceModal: {
    create: 'MAINTENANCE_CREATE',
    update: 'MAINTENANCE_UPDATE',
    /* firstSectionTitle: 'EQUIPMENT_FIRST_SECTION_TITLE',
    secondSectionTitle: 'EQUIPMENT_SECOND_SECTION_TITLE',
    brand: 'EQUIPMENT_BRAND',
    reference: 'EQUIPMENT_REFERENCE',
    number: 'EQUIPMENT_NUMBER' */
  },
  equipmentMessage: {
    creationSuccess: 'EQUIPMENT_SUCCESS_MESSAGE'
  },
  equipmentAction: {
    edit: 'EQUIPMENT_EDIT',
    delete: 'EQUIPMENT_DELETE',
    scheduleMaintenance: 'SCHEDULE_MANTENANCE',
    addDocToEquipment: 'ADD_DOC_EQUIPMENT'
  },
  vehicleAction: {
    edit: 'VEHICLE_EDIT',
    delete: 'VEHICLE_DELETE',
  },
  equipmentDetail: {
    disable: 'EQUIPMENT_DISABLE',
    acquisitionDate: 'EQUIPMENT_ACQUISITION_DATE'
  }
}



// WEBPACK FOOTER //
// ./src/locales/equipment/index.ts